import { browserOnly } from './browserOnly';

/** Check if the browser is Safari */
export function isSafari() {
  return browserOnly(
    window =>
      /Safari/.test(window.navigator.userAgent) &&
      !/Chrome/.test(window.navigator.userAgent) &&
      !/CriOS/.test(window.navigator.userAgent) &&
      !/GSA/.test(window.navigator.userAgent) &&
      !/Chromium/.test(window.navigator.userAgent),
    () => false
  );
}
